import React from "react";

interface FundraiserCodeDisplayProps {
  code: string;
}

const FundraiserCodeDisplay: React.FC<FundraiserCodeDisplayProps> = ({
  code,
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Fundraiser Join Code</h1>
        <p style={styles.text}>
          Your fundraiser join code is <span style={styles.code}>{code}</span>.
          <br />
          Please share it with all your participants so they can join the
          fundraiser!
        </p>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    backgroundColor: "#f9f9f9",
  },
  card: {
    backgroundColor: "#ffffff",
    border: "2px solid #007bff",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    maxWidth: "500px",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#007bff",
    marginBottom: "15px",
  },
  text: {
    fontSize: "16px",
    color: "#333333",
    lineHeight: "1.6",
  },
  code: {
    fontWeight: "bold",
    color: "#000000",
    backgroundColor: "#fef3f0",
    padding: "2px 6px",
    borderRadius: "4px",
  },
};

export default FundraiserCodeDisplay;
